"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var mapStateToProps = function mapStateToProps(state, ownProps, _ref) {
  var playerId = _ref.playerId;

  var player = state.players[playerId];

  return {
    children: ownProps.children,
    fadeOpacity: ownProps.fadeOpacity,
    focused: player.focused
  };
};

exports.mapStateToProps = mapStateToProps;